import { flatten } from 'lodash';
import React, { isValidElement } from 'react';
import styled from 'styled-components';
import { Radio, RadioGroup } from '@zocdoc-frontend-common/components-radio';
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';
import { slate30 } from '@zocdoc-mezzanine/foundations-colors';
import { AddSubpatientButton } from './AddSubpatientButton';
export class SelectPatientRadioGroup extends RadioGroup {
    componentWillReceiveProps(newProps) {
        if (newProps.selectedValue !== this.props.selectedValue) {
            this.setState({
                ...this.state,
                selectedValue: newProps.selectedValue,
            });
        }
    }

    render() {
        const { children } = this.props;

        const radioNodes = flatten(children)
            .filter(isValidElement)
            .map((child, index) => {
                const {
                    value,
                    text,
                    className,
                    handleNewPatientClick,
                    ...childProps
                } = child.props;

                const attributes = filterToValidAttributes(childProps);

                /**
                 * react-hot-loader instruments React classes, so we can't rely on simple
                 * strict equality
                 */
                if (
                    child.type.displayName === AddSubpatientButton.displayName
                ) {
                    return (
                        <AddSubpatientButton
                            key={index}
                            className={className}
                            onClick={handleNewPatientClick}
                            text={text}
                            {...attributes}
                        />
                    );
                }

                return (
                    <Radio
                        key={index}
                        className={className}
                        name={this.props.name}
                        onChange={this.handleChange}
                        orientation={this.props.orientation}
                        selectedValue={this.state.selectedValue}
                        text={text}
                        value={value}
                        {...attributes}
                    />
                );
            });

        return <StyledRadioGroup>{radioNodes}</StyledRadioGroup>;
    }
}

const StyledRadioGroup = styled.div`
    border: 1px solid ${slate30};
`;
